
import React from 'react';
import { Breadcrumb } from 'antd';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import './styles.css';

/**
 * @function
 * @name DynamicBreadcrumbs
 * @description render dyanmic breadcrumbs
 * @param {object} props
 * @param {object} props.breadcrumbs breadcrumbs data
 * 
 * @version 0.1.0
 * @since 0.1.0
 */
function DynamicBreadcrumbs({ breadcrumbs }) {
  return (
    <Breadcrumb className="Breadcrumb" separator=">" data-testid="dynamic-breadcrumbs">
      {breadcrumbs.map((item, index) => {
        const { current, loading, action, icon, type } = item;
        const labelInner = (
          <>
            {icon && <span className="crumb-icon" aria-hidden="true">{icon}</span>}
            <span className="crumb-label-text">{item.title}</span>
          </>
        );
        const content = current ? (
          <span
            aria-current="page"
            title={item.name}
            data-testid="breadcrumb-current"
            className={(loading ? 'crumb-loading ' : '') + 'crumb-current'}
          >
            {labelInner}
          </span>
        ) : (
          <Link to={item.url} title={item.name} className={loading ? 'crumb-loading' : ''}>
            {labelInner}
          </Link>
        );
        return (
          <Breadcrumb.Item key={index} className={(current ? 'is-current ' : '') + (type ? `crumb-${type}` : '')}>
            {content}
            {action && <span className="crumb-action" style={{ marginLeft: 8 }}>{action}</span>}
          </Breadcrumb.Item>
        );
      })}
    </Breadcrumb>
  );
}
DynamicBreadcrumbs.propTypes = {
  breadcrumbs: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      current: PropTypes.bool,
      loading: PropTypes.bool,
      action: PropTypes.node,
  icon: PropTypes.node,
  type: PropTypes.string,
    }).isRequired)
};

export default DynamicBreadcrumbs;
